import { DarkerTheme, FadeMainGreen } from "../../Styles/colors";

export const IconStyle = {
	padding: ".5rem",
	width: "4.5rem",
	height: "4.5rem",
	borderRadius: "50%",
	margin: "auto",
};

export const tabsStyle = {
	color: DarkerTheme,
	fontWeight: "600",
	borderTopRightRadius: "15px",
	borderTopLeftRadius: "15px",
	transition: "ease-in .3s",
};
